/* eslint-disable i18n-scan/no-inline-content */
import React, { forwardRef } from 'react'
import { SearchModal } from '@paypalcorp/dx-ui-react/dist/umd'
import PropTypes from 'prop-types'
import { Avatar, Col, Row } from '@paypalcorp/pp-react'
import { useMessage } from '../../../hooks'
import { getUserType } from '../../../utils/user-utils'
import { NavMenu } from './nav-menu'

export const LoggedNav = forwardRef(
  ({ currentUser, menuList, profileMenuItems, ...rest }, ref) => {
    const localizedMsg = useMessage()
    const accountType = getUserType(currentUser)

    const FULL_NAME =
      accountType === 'IDENTITY'
        ? currentUser?.email
        : currentUser?.firstName + ' ' + currentUser?.lastName
    let INITIALS

    if (accountType === 'IDENTITY') {
      INITIALS = currentUser?.email.trim().toUpperCase().slice(0, 1)
    } else {
      INITIALS =
        (currentUser?.firstName
          ? currentUser?.firstName.trim().toUpperCase().slice(0, 1)
          : '') +
        (currentUser?.lastName
          ? currentUser?.lastName.trim().toUpperCase().slice(0, 1)
          : '')
    }
    const maxLength = 12
    const profileNav = [
      {
        title:
          FULL_NAME.length > maxLength
            ? FULL_NAME.substr(0, maxLength) + '...'
            : FULL_NAME,
        menuItems: profileMenuItems,
      },
    ]

    return (
      <nav className="dev_dash__logged_nav--container" ref={ref} {...rest}>
        <Row className="flex items-center top-nav-items-center">
          <Col xs={4} className="dev_dash__logged_nav--container-flex">
            <div className="dev_dash__logged_nav--LoggedNav-title">
              {localizedMsg('top-nav.logged.title')}
            </div>
            <div id="dev_dash__logged_nav--search-id">
              <SearchModal />
            </div>
          </Col>
          <Col xs={8}>
            <Row className="flex items-center flex-end">
              <NavMenu menuList={menuList} />
              <div className="dev_dash__logged_nav-item_link__border" />
              <div className="flex items-center ml-10">
                <Avatar initials={INITIALS} size="xs" />
                <NavMenu menuList={profileNav} />
              </div>
            </Row>
          </Col>
        </Row>
      </nav>
    )
  },
)

LoggedNav.displayName = 'LoggedNav'

LoggedNav.propTypes = {
  currentUser: PropTypes.object,
  profileMenuItems: PropTypes.array,
  menuList: PropTypes.array,
}
